<template>
  <div class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 animate-modalFade">
    <div class="w-full max-w-md bg-gray-800 text-gray-300 rounded-lg p-4 flex flex-col gap-4 relative shadow-lg border border-gray-700 animate-scaleIn">
      <!-- Header -->
      <div class="flex justify-between items-center">
        <h2 class="text-lg font-semibold text-gray-100">ยืนยันการไล่ออก</h2>
        <button @click="$emit('close')" class="text-gray-300 hover:text-indigo-300 group">
          <i class="fas fa-times text-base group-hover:scale-110 transition-transform duration-200"></i>
        </button>
      </div>

      <!-- Content -->
      <div class="text-center text-gray-300">
        <p>คุณต้องการไล่ออก "{{ villager.name }}" หรือไม่?</p>
        <p class="text-red-400 text-sm mt-2">การกระทำนี้ไม่สามารถย้อนกลับได้</p>
      </div>

      <!-- Actions -->
      <div class="flex justify-end gap-2">
        <button
          @click="$emit('close')"
          class="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md transition-colors duration-200 border border-gray-600"
        >
          ยกเลิก
        </button>
        <button
          @click="confirmDismiss"
          class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md transition-colors duration-200 border border-red-700"
          :disabled="isLoading"
        >
          <span v-if="!isLoading">ยืนยัน</span>
          <div v-else class="animate-spin rounded-full h-4 w-4 border-t-2 border-white"></div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { projectFunctions } from '@/firebase/config';
import getUser from '@/composables/getUser';

export default {
  name: 'DismissVillagerModal',
  props: {
    villager: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'dismissed'],
  setup(props, { emit }) {
    const { user } = getUser();
    const isLoading = ref(false);
    const gameActions = projectFunctions.httpsCallable('gameActions');

    const confirmDismiss = async () => {
      if (!user.value) return;
      isLoading.value = true;
      try {
        const result = await gameActions({
          action: 'villagerActions',
          subAction: 'dismissVillager',
          villagerId: props.villager.id,
        });
        if (result.data.success) {
          emit('dismissed', props.villager);
          emit('close');
        } else {
          alert(result.data.error || 'เกิดข้อผิดพลาดระหว่างไล่ออก');
        }
      } catch (e) {
        console.error('Dismiss error:', e);
        alert('เกิดข้อผิดพลาดระหว่างไล่ออก');
      } finally {
        isLoading.value = false;
      }
    };

    return {
      isLoading,
      confirmDismiss,
    };
  },
};
</script>

<style scoped>
@keyframes modalFade {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-modalFade {
  animation: modalFade 0.3s ease-out;
}
@keyframes scaleIn {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.animate-scaleIn {
  animation: scaleIn 0.3s ease-out;
}
</style>